module.exports = __webpack_public_path__ + "media/images/gallery/constellations/cassiopeia/cas_names-e1375e1890fcf1f52a9b89304e75233c.gif";